/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import Component from '@glimmer/component';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import HotelAndMarketRevenueInsightFilterDisplayBar from 'lumen/components/hotel-and-market/revenue-insight/filter-display-bar';
import HotelAndMarketRevenueInsightTablesTableBreakdownDetail from 'lumen/components/hotel-and-market/revenue-insight/tables/table-breakdown-detail';

interface HotelAndMarketRevenueInsightTabsTabSegmentationTableSignature {
  Args: {
    filterText: unknown;
    params: unknown;
  };
}

export default class HotelAndMarketRevenueInsightTabsTabSegmentationTable extends Component<HotelAndMarketRevenueInsightTabsTabSegmentationTableSignature> {
  @computed('args.params.allModifiedSegmentationObjects')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get allModifiedSegmentationObjects() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.params?.allModifiedSegmentationObjects;
  }

  @computed('args.params.blockName')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get blockName() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.params?.blockName;
  }

  @computed('blockName', 'allModifiedSegmentationObjects.[]')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showTop200Info() {
    // Don't show it if it's still loading or for one of the blocks we don't do aggregations for
    if (
      !this.allModifiedSegmentationObjects ||
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      !this.allModifiedSegmentationObjects.length ||
      this.blockName === 'subscription_id' ||
      this.blockName === 'pickup'
    ) {
      return false;
    }

    // Check if the last row is aggregated
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const isLastRowAggregated =
      this.allModifiedSegmentationObjects[
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.allModifiedSegmentationObjects.length - 1
      ].isAggregatedRow;

    if (isLastRowAggregated) {
      return true;
    }

    // If it's categories, the last child could be an aggragted row
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const isLastRowOfCategoryAggregated =
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.allModifiedSegmentationObjects.some(
        // @ts-expect-error: Incorrect type
        (category) =>
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
          category.children?.[category.children.length - 1]?.isAggregatedRow,
      );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return isLastRowOfCategoryAggregated;
  }

  <template>
    <div class="flex h-full flex-col overflow-hidden">
      <HotelAndMarketRevenueInsightFilterDisplayBar
        @blockName={{this.blockName}}
        {{! @glint-expect-error: Incorrect type }}
        @filterText={{@filterText}}
        @showTop200Info={{this.showTop200Info}}
      />
      <div class="flex-1 overflow-y-auto">
        {{! @glint-expect-error: Incorrect type }}
        {{#if @params.isLoading}}
          <div class="loading-bar-container">
            <PrismLoadingBar />
          </div>
        {{else}}
          <HotelAndMarketRevenueInsightTablesTableBreakdownDetail
            {{! @glint-expect-error: Incorrect type }}
            @allModifiedSegmentationObjects={{@params.allModifiedSegmentationObjects}}
            {{! @glint-expect-error: Incorrect type }}
            @blockDisplayName={{@params.blockDisplayName}}
            @blockName={{this.blockName}}
            {{! @glint-expect-error: Incorrect type }}
            @visibleKpis={{@params.visibleKpis}}
          />
        {{/if}}
      </div>
    </div>
  </template>
}
